import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Paperclip } from "lucide-react";
import { api } from "../../lib/api";

export const RequestsTab = () => {
  const [items, setItems] = useState(null);

  const load = () => api("/admin/richieste").then(setItems).catch((e) => toast.error(e.message));
  useEffect(() => { load(); }, []);

  const toggle = async (r) => {
    try {
      await api(`/admin/richieste/${r.id}`, { method: "PUT", body: { letta: !r.letta } });
      load();
    } catch (e) {
      toast.error(e.message);
    }
  };

  if (!items) return <Loader2 className="animate-spin text-forest-glow mx-auto" size={28} />;

  return (
    <div data-testid="admin-requests" className="space-y-4">
      {items.length === 0 && <p className="text-cement text-sm border border-steel bg-card p-8 text-center">Nessuna richiesta di preventivo ricevuta.</p>}
      {items.map((r) => (
        <article key={r.id} data-testid={`admin-request-${r.id}`} className={`bg-card border p-5 ${r.letta ? "border-steel opacity-70" : "border-forest-mid"}`}>
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="text-white font-semibold text-sm">{r.nome} {r.azienda && <span className="text-cement font-normal">· {r.azienda}</span>}</p>
              <p className="text-xs text-cement mt-1">
                <a href={`mailto:${r.email}`} className="hover:text-forest-glow">{r.email}</a> · <a href={`tel:${r.telefono}`} className="hover:text-forest-glow">{r.telefono}</a>
                {r.localita && <> · {r.localita}</>}
              </p>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-forest-glow mt-1.5">{r.tipo}</p>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-mono text-[10px] text-cement/70">{new Date(r.created_at).toLocaleString("it-IT")}</span>
              <button data-testid={`admin-request-read-${r.id}`} onClick={() => toggle(r)} className="btn-ghost !px-3 !py-1.5 !text-[10px]">
                {r.letta ? "Segna da leggere" : "Segna letta"}
              </button>
            </div>
          </div>
          <p className="text-sm text-metal/80 mt-3 whitespace-pre-wrap">{r.messaggio}</p>
          {r.attachments?.length > 0 && (
            <p className="text-xs text-cement mt-3 flex items-center gap-2 flex-wrap">
              <Paperclip size={13} className="text-forest-glow" />
              {r.attachments.map((a) => a.name).join(", ")}
            </p>
          )}
        </article>
      ))}
    </div>
  );
};
